import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

// Safe Link component that handles router context issues
const SafeLink: React.FC<LinkProps> = ({ children, to, ...props }) => {
  try {
    return (
      <RouterLink to={to} {...props}>
        {children}
      </RouterLink>
    );
  } catch (error) {
    // Fallback to regular anchor tag if router context is not available
    console.warn('Router context not available, using fallback link:', error);
    return (
      <a href={to as string} {...props}>
        {children}
      </a>
    );
  }
};

export default SafeLink;
